// extracted by mini-css-extract-plugin
module.exports = {"addressBox":"MainMap_addressBox__3G33_","address_lon":"MainMap_address_lon__3dYLl","myAdminCodeWra":"MainMap_myAdminCodeWra__2mZmi"};